var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 512,
    height: 512,
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 512,
    height: 256,
    transform: "translate(0 256)",
    fill: "#496e2d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M377.332,199.376a48.311,48.311,0,0,0-45.554-32.239h-41.4a48.3,48.3,0,0,0-48.3,48.3,48.846,48.846,0,0,0,6.358,24.15c-15.373-.126-29.6.106-38.557,0V192.264l1.9-1.9c8.539-8.539,5.691-22.77,5.691-22.77s-14.229-2.846-22.767,5.693l-9.952,9.952h-11.1a44.274,44.274,0,0,0-44.274,44.274h32.2v36.224a38.511,38.511,0,0,0,3,14.943l-11.048,9.207h-16.1v-16.1h-16.1v32.2h72.448v32.2h-16.1v16.1h32.2v-32.2l14.758-17.71h34.883l14.758,17.71v16.1h-16.1v16.1h64.4V263.736a24.15,24.15,0,0,1,24.15-24.15c.343,0,.682.012,1.022.026a32.225,32.225,0,0,1,29.585-40.236ZM290.377,336.184V302.375h1.342l14.758,17.71v16.1h-16.1Z",
    fill: "#d80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/cy.4ec51f4b3fa4bb83d4e2336cf00e4a4d.svg";
export { ForwardRef as ReactComponent };